import { Content } from "@pathwright/ui/src/components/content/Content"
import { GridContainer, GridImage } from "../ui"

const Grid = ({ data, columns }) => (
  <Content.Container>
    <GridContainer>
      {data.images.slice(0, columns).map((image, i) => (
        <GridImage key={i} columns={columns}>
          <img src={image.src} alt={`Gallery Item ${i + 1}`} />
        </GridImage>
      ))}
    </GridContainer>
  </Content.Container>
)

export default Grid
